import { useSignal } from "@preact/signals-react"
import { postSubmit } from "@ui-seeker/utils"

import { WEBBACK_V2_API } from "@constants"
import { useToast, useUserApp } from "@hooks"
import { productPagesKpiSubmittedFilters, productPagesKpiReportFormIsOpen } from "../@signals"


export default function useProductPageKpiReportForm() {
    const { showToast } = useToast()
    const { userEmail, userCustomer } = useUserApp()

    const nameReport = useSignal('')
    const frequency = useSignal(null)
    const emailsReport = useSignal([userEmail])
    const conditions = useSignal([{id: 1, kpi: null, value: ''}])

    const resetFormData = () => {
        nameReport.value = ''
        frequency.value = null
        conditions.value = [{id: 1, kpi: null, value: ''}]
        emailsReport.value = [userEmail]
    }

    const deleteCondition = (id) => {
        conditions.value = conditions.value.filter(condition => condition.id !== id)
    }

    const addCondition = () => {
        const maxId = conditions.value.length > 0 ? Math.max(...conditions.value.map(e => e.id)) : 0
        conditions.value = [...conditions.value, { id: maxId + 1, kpi: null, value: '' }]
    }

    const updateCondition = (id, valueToUpdate) => {
        conditions.value = conditions.value.map(condition =>
            condition.id === id ? {...condition, ...valueToUpdate } : condition
        )
    }

    const handleOpenForm = () => {
        productPagesKpiReportFormIsOpen.value = true
    }

    const normalizeConditionFilters = (conditions) => {
        return conditions.value.filter(condition =>
            Object.values(condition).every(v => v !== '' && v !== null && v !== undefined)
        )
    }

    const handleSendToBack = () => {
        let apiUrl =`${WEBBACK_V2_API}/reports/create`

        if (frequency.value === 'now') {
            apiUrl = `${WEBBACK_V2_API}/reports/execute-now`
        }

        const payload = {
            nameReport: nameReport.value,
            frequency: frequency.value,
            emailsReport: emailsReport.value.join(","),
            reportType: 'productPageKpi',
            conditions: normalizeConditionFilters(conditions),
            filters: {
                country: productPagesKpiSubmittedFilters.value.country, retailer: productPagesKpiSubmittedFilters.value.retailer,
                brand: productPagesKpiSubmittedFilters.value.brand, skuGroup: productPagesKpiSubmittedFilters.value.skuGroup,
                sku: productPagesKpiSubmittedFilters.value.sku, id_customer: userCustomer,
                splitKpi: productPagesKpiSubmittedFilters.value.splitKpi
            }
        }

        showToast.promise(postSubmit(apiUrl, payload), {
            error: 'Error: Please try again later.',
            success: `Report successfully created.`,
        })
    }

    return {
        handleOpenForm,
        handleSendToBack,
        resetFormData,
        nameReport: nameReport,
        frequency: frequency,
        emailsReport: emailsReport,
        conditions: conditions,
        deleteCondition,
        addCondition,
        updateCondition
    }
}